import React from 'react'
import styled from 'styled-components'
import bugsnagClient from '../lib/bugsnag'

const ErrorPage = styled.div`
  color: #000;
  background: #fff;
  height: 100vh;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`

export default class Error extends React.Component {
  static async getInitialProps(ctx) {
    if (ctx.err) bugsnagClient.notify(ctx.err)

    return {}
  }
  render() {
    return (
      <ErrorPage>
        Something went wrong. Please contact ShipHero support.
      </ErrorPage>
    )
  }
}
